"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _repeatInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/repeat");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.renderFlexLayout = renderFlexLayout;
exports.registerFlexLayout = exports.BmFlexLayout = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _element = require("@blue/element");

var _layoutRegistry = require("../../registry/layout-registry");

var _renderLayout = require("./render-layout");

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)([" <bm-flex-layout .info=\"", "\" .items=\"", "\"></bm-flex-layout> "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t:host .container {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-wrap: wrap;\n\t\t\t}\n\n\t\t\t:host .row {\n\t\t\t\tflex-direction: row;\n\t\t\t}\n\n\t\t\t:host .row > * {\n\t\t\t\tmargin: 10px;\n\t\t\t}\n\n\t\t\t:host .row.grow > * {\n\t\t\t\tflex-grow: 1;\n\t\t\t}\n\n\t\t\t:host .row.alignCenter {\n\t\t\t\talign-items: center;\n\t\t\t}\n\n\t\t\t:host .row.alignStart {\n\t\t\t\talign-items: start;\n\t\t\t}\n\n\t\t\t:host .row.alignEnd {\n\t\t\t\talign-items: End;\n\t\t\t}\n\n\t\t\t:host .col {\n\t\t\t\tflex-direction: column;\n\t\t\t\tmargin: -10px;\n\t\t\t}\n\t\t"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<div class=\"", "\">\n\t\t\t\t", "\n\t\t\t</div>\n\t\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t<div class=\"container col\">\n\t\t\t", "\n\t\t</div>\n\t\t"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BmFlexLayout = /*#__PURE__*/function (_BmFormLayout) {
  (0, _inherits2.default)(BmFlexLayout, _BmFormLayout);

  var _super = (0, _createSuper2.default)(BmFlexLayout);

  function BmFlexLayout() {
    (0, _classCallCheck2.default)(this, BmFlexLayout);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(BmFlexLayout, [{
    key: "shouldUpdate",
    value: function shouldUpdate(changed) {
      if (!this.info || !this.items) {
        return false;
      }

      if (this.info) {
        this._info = BmFlexLayout.normalizeLayoutInfo(this.info);
      }

      return (0, _get2.default)((0, _getPrototypeOf2.default)(BmFlexLayout.prototype), "shouldUpdate", this).call(this, changed);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var rows = (0, _repeatInstanceProperty(_element))(this._info.options, function (row) {
        return _this.renderRow(_this.items, row);
      });
      return this.html(_templateObject(), rows);
    }
  }, {
    key: "renderRow",
    value: function renderRow(items, row) {
      var _this2 = this;

      var cols = (0, _repeatInstanceProperty(_element))(row.order, function (itemName) {
        return itemName;
      }, function (itemName) {
        return _this2.renderItem(items[itemName]);
      });
      return this.html(_templateObject2(), this._getClassMap(row), cols);
    }
  }, {
    key: "_getClassMap",
    value: function _getClassMap(opts) {
      var grow = opts.grow,
          alignItems = opts.alignItems;
      return (0, _element.classMap)({
        container: true,
        row: true,
        grow: Boolean(grow),
        alignStart: alignItems === 'start',
        alignCenter: alignItems === 'center',
        alignEnd: alignItems === 'end'
      });
    }
  }], [{
    key: "dependents",
    value: function dependents(info) {
      var _context;

      return (0, _reduce.default)(_context = BmFlexLayout.normalizeOptions(info.options)).call(_context, function (a, c) {
        return (0, _concat.default)(a).call(a, c.order);
      }, []);
    }
  }, {
    key: "normalizeOptions",
    value: function normalizeOptions(_opts) {
      var opts = (0, _map.default)(_opts).call(_opts, function (_opts) {
        return (0, _isArray.default)(_opts) ? {
          order: _opts
        } : _opts;
      });
      return opts;
    }
  }, {
    key: "normalizeLayoutInfo",
    value: function normalizeLayoutInfo(info) {
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, info), {}, {
        options: BmFlexLayout.normalizeOptions(info.options)
      });
    }
  }, {
    key: "is",
    get: function get() {
      return 'bm-flex-layout';
    }
  }, {
    key: "styles",
    get: function get() {
      return (0, _element.css)(_templateObject3());
    }
  }]);
  return BmFlexLayout;
}(_renderLayout.BmFormLayout);

exports.BmFlexLayout = BmFlexLayout;

function renderFlexLayout(info, items) {
  return (0, _element.html)(_templateObject4(), info, items);
}

var registerFlexLayout = function registerFlexLayout() {
  (0, _layoutRegistry.registerLayout)('flex', {
    renderer: renderFlexLayout,
    dependents: BmFlexLayout.dependents
  });
  (0, _element.register)(BmFlexLayout);
};

exports.registerFlexLayout = registerFlexLayout;
